<style scoped>
</style>

<template>
  <div>
    <Navbar></Navbar>
    <v-container fluid>
      <router-view />
    </v-container>
  </div>
</template>

<script>
import Navbar from "@/components/NavDashboard";

export default {
  name: 'AdminNav',
  components: {
    Navbar
  }
}
</script>
